"use client";
import { motion } from "framer-motion";
import { Card, CardContent } from "@/components/ui/card";
import { Shield, Droplets, Zap, Truck } from "lucide-react";

const features = [
  {
    icon: Shield,
    title: "Ultra Durable",
    description: "Withstands heavy traffic and daily wear",
  },
  {
    icon: Droplets,
    title: "Water Resistant",
    description: "Perfect for wet areas and easy to clean",
  },
  {
    icon: Zap,
    title: "Quick Application",
    description: "Professional installation in 2-3 days",
  },
  {
    icon: Truck,
    title: "Fast Shipping",
    description: "Free shipping on orders over $500",
  },
];

export function ConcrettaFeatures() {
  return (
    <section
      id="concretta-features"
      className="py-24"
      data-header-scheme="light"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-serif text-3xl md:text-4xl font-light text-foreground mb-4 tracking-tight">
            Why Choose Concretta?
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Premium microcement engineered for durability, beauty, and ease of
            application
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <Card className="border-border bg-card shadow-lg text-center h-full">
                <CardContent className="p-6">
                  <div className="inline-flex items-center justify-center w-12 h-12 bg-primary text-primary-foreground rounded-lg mb-4">
                    <feature.icon className="h-6 w-6" />
                  </div>
                  <h3 className="font-serif text-lg font-medium text-foreground mb-2 tracking-tight">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground text-sm">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
